// @flow

import { hpfetch } from '../util';
import type { notificationType } from '../../types';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<notificationType>> =>
  hpfetch(`notifications/${id}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<notificationType> =>
  hpfetch(`notifications/?limit=${limit}&offset=${offset}`);

export const getUnreadNotifications = (
  limit: number = 100,
  offset: number = 0,
) => hpfetch(`notifications/?limit=${limit}&offset=${offset}&read=False`);

export const markAsRead = (id: number) =>
  hpfetch(`notifications/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      read: true,
    }),
  });

export const markAsUnread = (id: number) =>
  hpfetch(`notifications/${id}/`, {
    method: 'PATCH',
    body: JSON.stringify({
      read: false,
    }),
  });

export const markAllAsRead = () =>
  hpfetch('notifications/mark_all_as_read/', {
    method: 'POST',
    body: JSON.stringify({}),
  }).catch(() => {
    console.log('DO NOTHING');
  });

export const textIosLink = () =>
  hpfetch('notifications/text_me_ios_link/', {
    method: 'POST',
  });
